module.exports = __webpack_public_path__ + "static/media/charcoalBust.045f9f7f.jpg";